import * as React from "react";
const CommunitiesTabIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <rect width={72} height={72} fill="#C9E9E9" rx={10} />
        <g clipPath="url(#a)">
            <path
                fill="#000"
                stroke="#000"
                d="M52.176 26.902v17.196a1.5 1.5 0 0 1-1.5 1.5H22.324a1.5 1.5 0 0 1-1.5-1.5V26.902a1.5 1.5 0 0 1 1.5-1.5H50.676a1.5 1.5 0 0 1 1.5 1.5Z"
            />
            <rect
                width={30.12}
                height={18.965}
                x={21.44}
                y={26.018}
                fill="#fff"
                rx={1}
            />
            <rect
                width={12.271}
                height={1.116}
                x={35.942}
                y={33.461}
                fill="#000"
                rx={0.4}
            />
            <rect
                width={7.809}
                height={1.116}
                x={35.942}
                y={35.692}
                fill="#000"
                rx={0.4}
            />
            <rect
                width={11.156}
                height={1.116}
                x={35.942}
                y={37.923}
                fill="#000"
                rx={0.4}
            />
            <path fill="#000" d="M21.32 25.672h30.241v2.918H21.32z" />
            <rect
                width={3.347}
                height={1.116}
                x={35.942}
                y={40.154}
                fill="#000"
                rx={0.4}
            />
            <rect
                width={1.116}
                height={1.116}
                x={48.772}
                y={26.709}
                fill="#fff"
                rx={0.558}
            />
            <rect
                width={1.116}
                height={1.116}
                x={46.54}
                y={26.709}
                fill="#fff"
                rx={0.558}
            />
            <rect
                width={1.116}
                height={1.116}
                x={44.309}
                y={26.709}
                fill="#fff"
                rx={0.558}
            />
            <rect
                width={2.231}
                height={1.116}
                x={40.404}
                y={40.154}
                fill="#000"
                rx={0.4}
            />
            <rect
                width={10.04}
                height={10.04}
                x={23.671}
                y={32.346}
                fill="#C0ACFA"
                rx={1}
            />
            <path stroke="#000" d="M51.56 28.749H20.324" />
        </g>
        <rect
            width={11}
            height={11}
            x={46.494}
            y={40.91}
            fill="#E2FF05"
            stroke="#000"
            rx={5.5}
        />
        <path
            fill="#000"
            d="M51.637 46.053v-1.786a.357.357 0 0 1 .714 0v1.786h1.786a.357.357 0 0 1 0 .714h-1.786v1.786a.357.357 0 0 1-.714 0v-1.786h-1.786a.357.357 0 1 1 0-.714h1.786Z"
        />
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M4 4h64v64H4z" />
            </clipPath>
        </defs>
    </svg>
);
export default CommunitiesTabIcon;
